module.exports = __webpack_public_path__ + "img/g3.6385048e.png";